<!-- A real <button>, not a styled div: it has to be reachable by keyboard and announce itself.
     Lives in the top bar so it never floats over the page's own buttons. Red and labelled, because a
     bare speech-bubble icon among the other tools didn't tell anyone what it was for. -->
<button
  type="button"
  class="bct-launcher"
  [class.bct-launcher--busy]="busy()"
  [class.on]="menuOpen()"
  [attr.aria-expanded]="menuOpen()"
  aria-haspopup="menu"
  aria-label="Feedback: report a bug or request a feature"
  aria-keyshortcuts="Control+Shift+B"
  matTooltip="Something not working, or an idea? Report a bug or request a feature (Ctrl+Shift+B)"
  [matTooltipDisabled]="menuOpen()"
  [disabled]="busy()"
  (click)="toggleMenu()">
  <mat-icon aria-hidden="true">{{ busy() ? 'hourglass_top' : 'bug_report' }}</mat-icon>
  <span class="bct-launcher__label">Feedback</span>
</button>

<!-- Drops down under the launcher, right-aligned with it like the other top-bar menus. -->
@if (menuOpen()) {
  <div class="bct-menu" role="menu" aria-label="Report a bug or request a feature">
    <div class="bct-menu__head">Feedback</div>
    <button type="button" role="menuitem" class="bct-menu__item" (click)="start(TicketType.Bug)">
      <mat-icon aria-hidden="true">bug_report</mat-icon>
      Report a bug
    </button>
    <button type="button" role="menuitem" class="bct-menu__item" (click)="start(TicketType.Feature)">
      <mat-icon aria-hidden="true">lightbulb</mat-icon>
      Request a feature
    </button>
  </div>
}
